import React from "react";
import { NavDropdown } from "react-bootstrap";
import NavBarMYZ from "../../../assets/navbar-icon-myz.jpg";
import NavBarAnchortown from "../../../assets/navbar-icon-anchortown.jpg";

const rulesAndGameAidsLinks = [
  { href: "/mutant-year-zero-civil-war-rules", label: "Civil War Rules" },
  { href: "/ark-projects-summary", label: "Ark Projects Summary" },
  { href: "/mutant-year-zero-beast-training", label: "Beast Training" },
  { href: "/mutant-year-zero-scrap-rules", label: "Custom Scrap Rules" },
  { href: "/mutant-year-zero-errata", label: "Errata" },
  {
    href: "/mutant-year-zero-handwave-travel-rules",
    label: "Handwave Travel Rules",
  },
  { href: "/mutant-generator", label: "Mutant Generator" },
  {
    href: "/mutant-year-zero-sector-generator",
    label: "Roll20: Sector Generator",
  },
  {
    href: "/mutant-year-zero-rot-critical-injuries",
    label: "Rot Critical Injuries",
  },
  { href: "/scrap-generator", label: "Scrap Generator" },
  { href: "/mutant-year-zero-scenes", label: "Scenes" },
];

const mapsAndMiscLinks = [
  {
    href: "/mutant-year-zero-anchortown-population-notable-events",
    label: "Anchortown Population & Notable Events",
  },
  {
    href: "/mutant-year-zero-anchortown-graveyard",
    label: "Anchortown Graveyard",
  },
  { href: "/mutant-year-zero-cover-gallery", label: "Anchortown Art Gallery" },
  { href: "/mutant-year-zero-anchortown-map", label: "Anchortown Map" },
  {
    href: "/mutant-year-zero-anchortown-map-grid-exploration",
    label: "Anchortown Map: Grid Exploration",
  },
];

const session61To65Links = [
  {
    href: "/mutant-year-zero-session-64_65-anchortown",
    label: "Anchortown: Session 64-65: 10-27-2023",
  },
  {
    href: "/mutant-year-zero-session-63-anchortown",
    label: "Anchortown: Session 63: 09-15-2023",
  },
  {
    href: "/mutant-year-zero-session-61-62-anchortown",
    label: "Anchortown: Session 61-62: 09-01-2023",
  },
];

const session51To60Links = [
  {
    href: "/mutant-year-zero-session-58-60-anchortown",
    label: "Anchortown: Session 58-60: 07-22-2023",
  },
  {
    href: "/mutant-year-zero-session-56-57-anchortown",
    label: "Anchortown: Session 56-57: 05-19-2023",
  },
  {
    href: "/mutant-year-zero-session-55-anchortown",
    label: "Anchortown: Session 55: 03-18-2023",
  },
  {
    href: "/mutant-year-zero-session-54-anchortown",
    label: "Anchortown: Session 54: 03-04-2023",
  },
  {
    href: "/mutant-year-zero-session-53-anchortown",
    label: "Anchortown: Session 53: 02-17-2023",
  },
  {
    href: "/mutant-year-zero-session-52-anchortown",
    label: "Anchortown: Session 52: 02-04-2023",
  },
  {
    href: "/mutant-year-zero-session-51-anchortown",
    label: "Anchortown: Session 51: 12-16-2022",
  },
];

const session41To50Links = [
  {
    href: "/mutant-year-zero-session-50-anchortown",
    label: "Anchortown: Session 50: 12-03-2022",
  },
  {
    href: "/mutant-year-zero-session-49-anchortown",
    label: "Anchortown: Session 49: 11-11-2022",
  },
  {
    href: "/mutant-year-zero-session-48-anchortown",
    label: "Anchortown: Session 48: 10-28-2022",
  },
  {
    href: "/mutant-year-zero-session-47-anchortown",
    label: "Anchortown: Session 47: 10-14-2022",
  },
  {
    href: "/mutant-year-zero-session-46-anchortown",
    label: "Anchortown: Session 46: 09-30-2022",
  },
  {
    href: "/mutant-year-zero-session-45-anchortown",
    label: "Anchortown: Session 45: 09-16-2022",
  },
  {
    href: "/mutant-year-zero-session-43_44-anchortown",
    label: "Anchortown: Session 43-44: 08-26-2022",
  },
  {
    href: "/mutant-year-zero-session-42-anchortown",
    label: "Anchortown: Session 42: 08-12-2022",
  },
  {
    href: "/mutant-year-zero-session-41-anchortown",
    label: "Anchortown: Session 41: 07-29-2022",
  },
];

const session31To40Links = [
  {
    href: "/mutant-year-zero-session-40-anchortown",
    label: "Anchortown: Session 40: 07-15-2022",
  },
  {
    href: "/mutant-year-zero-session-39-anchortown",
    label: "Anchortown: Session 39: 06-24-2022",
  },
  {
    href: "/mutant-year-zero-session-38-anchortown",
    label: "Anchortown: Session 38: 05-13-2022",
  },
  {
    href: "/mutant-year-zero-session-37-anchortown",
    label: "Anchortown: Session 37: 04-15-2022",
  },
  {
    href: "/mutant-year-zero-session-36-anchortown",
    label: "Anchortown: Session 36: 04-01-2022",
  },
  {
    href: "/mutant-year-zero-session-35-anchortown",
    label: "Anchortown: Session 35: 03-18-2022",
  },
  {
    href: "/mutant-year-zero-session-34-anchortown",
    label: "Anchortown: Session 34: 03-04-2022",
  },
  {
    href: "/mutant-year-zero-session-33-anchortown",
    label: "Anchortown: Session 33: 02-04-2022",
  },
  {
    href: "/mutant-year-zero-session-32-anchortown",
    label: "Anchortown: Session 32: 01-22-2022",
  },
  {
    href: "/mutant-year-zero-session-31-anchortown",
    label: "Anchortown: Session 31: 01-07-2022",
  },
];

const session21To30Links = [
  {
    href: "/mutant-year-zero-session-30-anchortown",
    label: "Anchortown: Session 30: 12-17-2021",
  },
  {
    href: "/mutant-year-zero-session-29-anchortown",
    label: "Anchortown: Session 29: 12-03-2021",
  },
  {
    href: "/mutant-year-zero-session-28-anchortown",
    label: "Anchortown: Session 28: 11-19-2021",
  },
  {
    href: "/mutant-year-zero-session-27-anchortown",
    label: "Anchortown: Session 27: 11-05-2021",
  },
  {
    href: "/mutant-year-zero-session-26-anchortown",
    label: "Anchortown: Session 26: 10-22-2021",
  },
  {
    href: "/mutant-year-zero-session-25-anchortown",
    label: "Anchortown: Session 25: 10-08-2021",
  },
  {
    href: "/mutant-year-zero-session-24-anchortown",
    label: "Anchortown: Session 24: 09-25-2021",
  },
  {
    href: "/mutant-year-zero-session-23-anchortown",
    label: "Anchortown: Session 23: 09-11-2021",
  },
  {
    href: "/mutant-year-zero-session-22-anchortown",
    label: "Anchortown: Session 22: 08-07-2021",
  },
  {
    href: "/mutant-year-zero-session-21-anchortown",
    label: "Anchortown: Session 21: 07-23-2021",
  },
];

const session11To20Links = [
  {
    href: "/mutant-year-zero-session-18-19-20-anchortown",
    label: "Anchortown: Session 18-20: 07-09-2021",
  },
  {
    href: "/mutant-year-zero-session-17-anchortown",
    label: "Anchortown: Session 17: 05-22-2021",
  },
  {
    href: "/mutant-year-zero-session-16-anchortown",
    label: "Anchortown: Session 16: 05-07-2021",
  },
  {
    href: "/mutant-year-zero-session-15-anchortown",
    label: "Anchortown: Session 15: 04-24-2021",
  },
  {
    href: "/mutant-year-zero-session-14-anchortown",
    label: "Anchortown: Session 14: 04-09-2021",
  },
  {
    href: "/mutant-year-zero-session-13-anchortown",
    label: "Anchortown: Session 13: 03-28-2021",
  },
  {
    href: "/mutant-year-zero-session-12-anchortown",
    label: "Anchortown: Session 12: 03-14-2021",
  },
  {
    href: "/mutant-year-zero-session-11-anchortown",
    label: "Anchortown: Session 11: 02-27-2021",
  },
];

const session01To10Links = [
  {
    href: "/mutant-year-zero-session-10-anchortown",
    label: "Anchortown: Session 10: 02-12-2021",
  },
  {
    href: "/mutant-year-zero-session-09-anchortown",
    label: "Anchortown: Session 09: 01-30-2021",
  },
  {
    href: "/mutant-year-zero-session-08-anchortown",
    label: "Anchortown: Session 08: 01-16-2021",
  },
  {
    href: "/mutant-year-zero-session-07-anchortown",
    label: "Anchortown: Session 07: 01-02-2021",
  },
  {
    href: "/mutant-year-zero-session-06-anchortown",
    label: "Anchortown: Session 06: 12-18-2020",
  },
  {
    href: "/mutant-year-zero-session-05-anchortown",
    label: "Anchortown: Session 05: 12-05-2020",
  },
  {
    href: "/mutant-year-zero-session-04-anchortown",
    label: "Anchortown: Session 04: 11-21-2020",
  },
  {
    href: "/mutant-year-zero-session-03-anchortown",
    label: "Anchortown: Session 03: 11-06-2020",
  },
  {
    href: "/mutant-year-zero-session-02-anchortown",
    label: "Anchortown: Session 02: 10-23-2020",
  },
  {
    href: "/mutant-year-zero-session-01-anchortown",
    label: "Anchortown: Session 01: 10-09-2020",
  },
];

const renderLinks = (links) =>
  links.map((item) => (
    <NavDropdown.Item key={item.href} href={item.href}>
      {item.label}
    </NavDropdown.Item>
  ));

const MYZNavBar = () => {
  return (
    <NavDropdown title="Mutant Year Zero" id="myz-nav-dropdown">
      <NavDropdown.Header>
        <img src={NavBarMYZ} alt="MYZ" style={{ maxHeight: 40 }} />
      </NavDropdown.Header>

      <NavDropdown title="Rules and Game Aids" id="myz-rules-dropdown">
        {renderLinks(rulesAndGameAidsLinks)}
      </NavDropdown>

      <NavDropdown.Divider />

      <NavDropdown.Header>
        <img
          src={NavBarAnchortown}
          alt="Anchortown"
          style={{ maxHeight: 40 }}
        />
      </NavDropdown.Header>

      <NavDropdown title="Maps, Graveyard, Misc." id="myz-maps-dropdown">
        {renderLinks(mapsAndMiscLinks)}
      </NavDropdown>

      <NavDropdown title="Sessions 61-65" id="myz-sessions-61-65-dropdown">
        {renderLinks(session61To65Links)}
      </NavDropdown>

      <NavDropdown title="Sessions 51-60" id="myz-sessions-51-60-dropdown">
        {renderLinks(session51To60Links)}
      </NavDropdown>

      <NavDropdown title="Sessions 41-50" id="myz-sessions-41-50-dropdown">
        {renderLinks(session41To50Links)}
      </NavDropdown>

      <NavDropdown title="Sessions 31-40" id="myz-sessions-31-40-dropdown">
        {renderLinks(session31To40Links)}
      </NavDropdown>

      <NavDropdown title="Sessions 01-30" id="myz-sessions-01-30-dropdown">
        <NavDropdown title="Sessions 21-30" id="myz-sessions-21-30-dropdown">
          {renderLinks(session21To30Links)}
        </NavDropdown>

        <NavDropdown title="Sessions 11-20" id="myz-sessions-11-20-dropdown">
          {renderLinks(session11To20Links)}
        </NavDropdown>

        <NavDropdown title="Sessions 01-10" id="myz-sessions-01-10-dropdown">
          {renderLinks(session01To10Links)}
        </NavDropdown>
      </NavDropdown>
    </NavDropdown>
  );
};

export default MYZNavBar;
